"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowForBanxAndMint = void 0;
const constants_1 = require("../../../constants");
const utils_1 = require("../../../utils");
const makeCreateBondMultiOrdersTransactionWithAdditionalInstructions_1 = require("./makeCreateBondMultiOrdersTransactionWithAdditionalInstructions");
const borrowForBanxAndMint = ({ notBondTxns, orders: bondOrders, connection, wallet, onAfterSend, onError, onSuccess, isLedger, skipPreflight, additionalInstructions, additionalSigners, borrowInstruction, repayInstruction, extraAddressesForLookupTable }) => __awaiter(void 0, void 0, void 0, function* () {
    const bondTransactionsAndSignersChunks = yield Promise.all(bondOrders.map((order) => {
        var _a;
        return (0, makeCreateBondMultiOrdersTransactionWithAdditionalInstructions_1.makeCreateBondMultiOrdersTransactionWithAdditionalInstructions)({
            marketPubkey: order.borrowNft.bondParams.marketPubkey,
            fraktMarketPubkey: order.borrowNft.bondParams.whitelistEntry.fraktMarket,
            oracleFloorPubkey: order.borrowNft.bondParams.oracleFloor,
            whitelistEntryPubkey: (_a = order.borrowNft.bondParams.whitelistEntry) === null || _a === void 0 ? void 0 : _a.publicKey,
            nftMint: order.borrowNft.mint,
            bondOrderParams: order.bondOrderParams,
            connection,
            wallet,
            additionalInstructions,
            additionalSigners,
            borrowInstruction,
            repayInstruction,
            extraAddressesForLookupTable
        });
    }));
    const fastTrackBorrows = bondTransactionsAndSignersChunks
        .filter((txnAndSigners) => txnAndSigners.createAndSellBondsIxsAndSigners.lookupTablePublicKeys.map((lookup) => lookup.addresses).flat()
        .length <= constants_1.MAX_ACCOUNTS_IN_FAST_TRACK)
        .map((txnAndSigners) => txnAndSigners.createAndSellBondsIxsAndSigners);
    const lookupTableBorrows = bondTransactionsAndSignersChunks.filter((txnAndSigners) => txnAndSigners.createAndSellBondsIxsAndSigners.lookupTablePublicKeys.map((lookup) => lookup.addresses).flat()
        .length > constants_1.MAX_ACCOUNTS_IN_FAST_TRACK);
    const firstChunk = [
        ...lookupTableBorrows
            .map((chunk) => ({
            transaction: chunk.createLookupTableTxn,
            signers: [],
        }))
            .flat(),
    ];
    const secondChunk = [
        ...lookupTableBorrows
            .map((chunk) => chunk.extendLookupTableTxns.map((transaction) => ({
            transaction,
            signers: [],
        })))
            .flat(),
    ];
    const createAndSellBondsIxsAndSignersChunk = [
        ...lookupTableBorrows.map((chunk) => chunk.createAndSellBondsIxsAndSigners).flat(),
    ];
    return yield (0, utils_1.signAndSendV0TransactionWithLookupTablesSeparateSignaturesWithAdditionalMessages)({
        notBondTxns,
        createLookupTableTxns: firstChunk.map((txn) => txn.transaction),
        extendLookupTableTxns: secondChunk.map((txn) => txn.transaction),
        v0InstructionsAndSigners: createAndSellBondsIxsAndSignersChunk,
        fastTrackInstructionsAndSigners: fastTrackBorrows,
        additionalMessages: [],
        // lookupTablePublicKey: bondTransactionsAndSignersChunks,
        isLedger,
        skipPreflight,
        skipTimeout: fastTrackBorrows.length > 0 && firstChunk.length === 0,
        connection,
        wallet,
        commitment: 'confirmed',
        onAfterSend,
        onSuccess,
        onError,
    });
});
exports.borrowForBanxAndMint = borrowForBanxAndMint;
